import React, { useEffect, useState, useRef, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';

import ReactTable from 'components/ReactTable/ReactTable.js';

import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

//servicios
import { wsGet } from 'services/WService';
import { getPolygonPath } from 'services/PolygonPath';

//modal imports
import { Polygon, Marker, InfoWindow } from '@react-google-maps/api';
import wkt from 'wkt';
import { wsFindBy, wsUpdate, wsGetAll } from 'services/WService';
import {
  Add,
  Edit,
  Save,
  Visibility,
  Clear,
  Restore,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LocationOff,
  LocationOn,
  GpsOff,
  GpsFixed,
  VisibilityOff,
  Map,
} from '@material-ui/icons';
import {
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from '@material-ui/core';
import AddressModal from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Modal/Address/AddressModal';
import { WithApp } from 'contexts/appContext';
import Legend from 'components/Tvendo/Common/Legend';
import LayerCombo, { LayerColorIcon } from 'components/Tvendo/Common/LayerCombo';
import LayerLegend from 'components/Tvendo/Common/LayerLegend';
import { Link } from 'react-router-dom';
import useLayerContext from 'contexts/layerContext';
import GoogleMapCustom from 'components/Tvendo/Common/GoogleMapCustom';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    backgroundColor: '#8e24aa',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  grid: {
    marginTop: '20px',
    marginButtom: '20px',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  details: {
    '& span': {
      marginRight: '20px',
      fontWeight: 600,
      fontSize: '1rem',
    },
  },
  detailsHover: {
    '& span': {
      marginLeft: '20px',
      fontWeight: 600,
      fontSize: '1rem',
      color: '#02c102',
    },
  },
  btnEye: {
    marginRight: '20px',
    '& span': {
      marginRight: 0,
    },
  },
  divStyle: {
    padding: '4px',
    listStyle: 'none',
    background: '#c8f7ec',
    borderRadius: '5px',
    '& span': {
      fontSize: '15px',
      fontWeight: 500,
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Código SN', accessor: 'CardCode', width: 150 },
  { Header: 'Socio Negocio', accessor: 'CardName' },
  { Header: 'Dirección', accessor: 'Address2' },
  { Header: 'Dirección fiscal', accessor: 'billAddress' },
  { Header: '', accessor: 'stateImg', width: 50, excelEnabled: false },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: 'Latitud', accessor: 'latitude', width: 150 },
  { Header: 'Longitud', accessor: 'longitude', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function ModalMapRouteEdit(props) {
  const classes = useStyles();
  const showNotify = props.showNotify;

  const [openInfo, setOpenInfo] = useState(false);
  const [infoData, setInfoData] = useState({});
  const { layers, selectedLayer, setSelectedDivition, setSelectedLayer, filteredLayers } = useLayerContext();

  const { showModal, setShowModal, routeId, setRouteId } = props;

  const handleClose = () => {
    setShowModal(false);
    setButtonUpdate(false);
    setRoute({});
    setAddresses([]);
    setRoutesRefference([]);
    setNewPolygon(null);
    setMapCenter(undefined);
    setRouteId(null);
    setDraggable({
      state: false,
      icon: '',
      idAddress: null,
    });
  };

  //#region  modal dentro del modal
  const [open, setOpen] = useState(false);

  const [geometryZone, setGeometryZone] = useState({});

  const handleClickOpen = () => {
    setOpen(true);
  };

  const eventClose = () => {
    setOpen(false);
  };
  //#endregion

  const [buttonUpdate, setButtonUpdate] = useState(false);

  const [route, setRoute] = useState({});
  const [stateFilter, setStateFilter] = useState('A');
  const [originalRoute, setOriginalRoute] = useState();
  const [routeHistory, setRouteHistory] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [selectedBureau, setSelectedBureau] = useState();
  const [showMarkerLabels, setShowMarkerLabels] = useState(false);

  const [draggable, setDraggable] = useState({}); //activar editar direccion
  const [newMarker, setNewMarker] = useState({ lat: 0, lng: 0 }); //activar editar direccion

  const [routesRefference, setRoutesRefference] = useState([]);
  const [mapRef, setMapRef] = useState(null);
  const routePolygon = useRef(null);
  const [newPolygon, setNewPolygon] = useState(null);
  const newPolygonRef = useRef(null);
  const [mapCenter, setMapCenter] = useState({
    lat: -14.836673004938541,
    lng: -74.9369324126855,
  });
  const [hoverDescription, setHoverDescription] = useState(null);

  const [showModalAddress, setShowModalAddress] = useState(false); //Abrir modal de direcciones
  const [objAddress, setObjAddress] = useState({}); // se llena de la direccion que seleccione para editar
  const [showAddresses, setShowAddresses] = useState(true);
  const [showOriginalGeometry, setShowOriginalGeometry] = useState(true);
  const [showReferenceRoutes, setShowReferenceRoutes] = useState(true);

  useEffect(() => {
    if (layers === undefined) return;
    if (route.base_layer_id === undefined) return;
    let selected = layers.find((layer) => layer.id === parseInt(route.base_layer_id));
    setSelectedDivition(selected.divition);
    setSelectedLayer(selected);
  }, [route.base_layer_id, layers]);

  const filteredRefferenceRoutes = useMemo(() => {
    if (selectedLayer === undefined) return routesRefference;
    if (selectedLayer.id === undefined){
      let layerdIds = filteredLayers.map((layer) => layer.id);
      return routesRefference.filter((route) => layerdIds.includes(parseInt(route.base_layer_id)));
    };
    return routesRefference.filter((route) => parseInt(route.base_layer_id) === selectedLayer.id);
  }, [routesRefference, selectedLayer]);

  async function getRoute(bureauId = undefined) {
    let queryBureau = `&filter_type=${stateFilter}`;
    if (bureauId !== undefined) {
      queryBureau += '&base_bureau_id=' + bureauId;
    }
    let [response, responseAddreses] = await Promise.all([
      wsGet('base/route', routeId),
      wsGetAll(`base/route/${routeId}/addresses?with_bureaus=Y${queryBureau}`),
    ]);

    let zoneFirstPoint;
    if (response.data.zone.geometry !== null) {
      zoneFirstPoint = wkt.parse(response.data.zone.geometry).coordinates[0][0];
    }

    if (response.success) {
      let latLngMarker;
      if (responseAddreses.success) {
        if (responseAddreses.data.length > 0) {
          latLngMarker = responseAddreses.data.find((element) => {
            if (parseFloat(element.latitude) !== 0) {
              return parseFloat(element.latitude);
            }
            return undefined;
          });
        }
        setAddresses(responseAddreses.data);
        // setAddresses(responseAddreses.data.map(data => {
        //   return {...data, Address2: data.Address2.replace('MZ', 'Manzana')};
        // }));
      }

      if (!!responseAddreses.bureaus) {
        setBureaus(responseAddreses.bureaus);
      }

      if (response.data.geometry !== null) {
        response.data.geometry = wkt.parse(response.data.geometry).coordinates[0].map((point) => {
          return {
            lng: point[0],
            lat: point[1],
          };
        });
        response.data.geometry.pop();
        setMapCenter(response.data.geometry[0]);
      } else if (response.data.geometry === null && latLngMarker !== undefined) {
        setMapCenter({
          lat: parseFloat(latLngMarker.latitude),
          lng: parseFloat(latLngMarker.longitude),
        });
      } else {
        if (response.data.zone.latitude !== null && response.data.zone.longitude !== null) {
          setMapCenter({
            lat: response.data.zone.latitude,
            lng: response.data.zone.longitude,
          });
        } else {
          if (response.data.zone.geometry !== null) {
            setMapCenter({
              lat: zoneFirstPoint[1],
              lng: zoneFirstPoint[0],
            });
          }
        }
      }
      setRoute(response.data);
      setGeometryZone({
        lat: response.data.zone.latitude || zoneFirstPoint[1],
        lng: response.data.zone.longitude || zoneFirstPoint[0],
      });
      return response.data;
    }
  }

  async function getRoutesReference(route) {
    let response = await wsFindBy('base/route', 'base_zone_id', route.base_zone_id);
    if (response.success) {
      for (let i = 0; i < response.data.length; i++) {
        let row = response.data[i];
        if (!!row.geometry) {
          row.geometry = wkt.parse(row.geometry).coordinates[0].map((point) => {
            return {
              lng: point[0],
              lat: point[1],
            };
          });
        }
      }
      let currentRouteIndex = response.data.findIndex((r) => r.id == route.id);
      response.data.splice(currentRouteIndex, 1);
      setRoutesRefference(response.data);
    }
  }

  async function createPolygon() {
    if (route.geometry != null) {
      showNotify('ya existe un poígono', 'info');
      return;
    }
    if (newPolygon != null) {
      let coordinates = getPolygonPath(newPolygonRef.current);

      if (coordinates.length <= 4) {
        coordinates.push(coordinates[0]);
      }

      let wktString = wkt.stringify({
        type: 'Polygon',
        coordinates: [coordinates],
      });
      let response = await wsUpdate('base/route', route.id, {
        geometry: wktString,
      });
      if (response.success) {
        showNotify(response.message);
        setNewPolygon(null);
        setRoute({
          ...route,
          geometry: coordinates.map((point) => {
            return {
              lng: point[0],
              lat: point[1],
            };
          }),
        });
        props.reload();
      }
      return;
    }

    mapRef.setZoom(14);

    let newPolyZone = {
      paths: [
        {
          lat: geometryZone.lat,
          lng: geometryZone.lng,
        },
        {
          lat: geometryZone.lat,
          lng: geometryZone.lng + 0.005,
        },
        {
          lat: geometryZone.lat - 0.005,
          lng: geometryZone.lng + 0.005,
        },
        {
          lat: geometryZone.lat - 0.005,
          lng: geometryZone.lng,
        },
      ],
    };

    let newPolyMarker = {};
    if (addresses) {
      let getAddressPolygon = addresses.find(
        (item) => parseFloat(item.latitude) !== 0 && parseFloat(item.longitude) !== 0,
      );

      if (getAddressPolygon !== undefined) {
        newPolyMarker = {
          paths: [
            {
              lat: parseFloat(getAddressPolygon.latitude),
              lng: parseFloat(getAddressPolygon.longitude),
            },
            {
              lat: parseFloat(getAddressPolygon.latitude),
              lng: parseFloat(getAddressPolygon.longitude) + 0.005,
            },
            {
              lat: parseFloat(getAddressPolygon.latitude) - 0.005,
              lng: parseFloat(getAddressPolygon.longitude) + 0.005,
            },
            {
              lat: parseFloat(getAddressPolygon.latitude) - 0.005,
              lng: parseFloat(getAddressPolygon.longitude),
            },
          ],
        };

        let center = newPolyMarker.paths[0];
        setMapCenter(center);
      }
    }

    setNewPolygon(Object.keys(newPolyMarker).length === 0 ? newPolyZone : newPolyMarker);
    let center = newPolyZone.paths[0];
    setMapCenter(center);
  }

  async function updatePolygon() {
    let coordinates = getPolygonPath(routePolygon.current);

    if (coordinates === false) console.error('Error en PolygonPath.js');

    let wktString = wkt.stringify({
      type: 'Polygon',
      coordinates: [coordinates],
    });
    let response = await wsUpdate('base/route', route.id, {
      geometry: wktString,
    });
    if (response.success) {
      showNotify(response.message);
      if (!!props.reload) {
        props.reload();
      }
      setRouteHistory([]);
      setOriginalRoute(undefined);
      setButtonUpdate(false);
    } else {
      showNotify(response.message, 'error');
    }
  }

  function startUpdate() {
    setOriginalRoute({ ...route });
    setRouteHistory([route.geometry]);
    setButtonUpdate(true);
  }

  function cancelUpdate() {
    setRoute({ ...originalRoute, geometry: [...originalRoute.geometry] });
    setRouteHistory([]);
    setOriginalRoute(undefined);
    setShowAddresses(true);
    setShowOriginalGeometry(true);
    setShowReferenceRoutes(true);
    setButtonUpdate(false);
  }

  function onMouseUpEdit() {
    let newPath = getPolygonPath(routePolygon.current).map((point) => {
      return {
        lng: point[0],
        lat: point[1],
      };
    });

    newPath.pop();

    setRouteHistory([...routeHistory, newPath]);
    setRoute({ ...route, geometry: newPath });
  }

  function removeVertex(fromStart = true) {
    let newPath = getPolygonPath(routePolygon.current).map((point) => {
      return {
        lng: point[0],
        lat: point[1],
      };
    });

    newPath.pop();

    if (newPath.length <= 3) {
      showNotify('No se pueden eliminar más vertices', 'info');
      return;
    }

    if (fromStart) {
      newPath.shift();
    } else {
      newPath.pop();
    }

    setRouteHistory([...routeHistory, newPath]);
    setRoute({ ...route, geometry: newPath });
  }

  function historyUndo() {
    if (routeHistory.length > 1) {
      setRoute({ ...route, geometry: routeHistory[routeHistory.length - 2] });
      setRouteHistory(routeHistory.slice(0, routeHistory.length - 1));
    }
  }

  async function udateMarker(latLng) {
    if (selectedLayer.id === undefined) {
      showNotify('Seleccione una capa', 'info');
      return;
    }
    let response = await wsUpdate('base/address', draggable.idAddress, {
      ...latLng,
      base_layer_id: selectedLayer.id,
      change_route: buttonUpdate,
    });
    if (response.success) {
      showNotify(response.message);
      getAddress();
      setDraggable({
        state: false,
        icon: '',
        idAddress: null,
      });
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function getAddress() {
    let queryBureau = `&filter_type=${stateFilter}`;
    if (selectedBureau !== undefined) {
      queryBureau += '&base_bureau_id=' + selectedBureau.id;
    }
    let response = await wsGetAll(`base/route/${routeId}/addresses?with_bureaus=Y${queryBureau}`);
    if (response.success) setAddresses(response.data);
  }

  useEffect(() => {
    if (routeId != null) {
      getRoute(selectedBureau?.id).then((route) => {
        getRoutesReference(route);
      });
    }
  }, [routeId, selectedBureau, stateFilter]);

  return (
    <Dialog fullScreen open={showModal} onClose={handleClose} TransitionComponent={Transition}>
      <Dialog onClose={eventClose} open={open} maxWidth="xl">
        <DialogTitle onClose={eventClose}>
          Listado de direcciones
          <br />
          {selectedBureau == undefined ? (
            <small
              style={{
                fontSize: '15px',
              }}
            >
              Sin filtro de mesa
            </small>
          ) : (
            <small
              style={{
                fontSize: '15px',
              }}
            >
              Filtro: {selectedBureau.description}
            </small>
          )}
          <IconButton aria-label="close" className={classes.closeButton} onClick={eventClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <ReactTable
            excelName="Listado-de-direcciones"
            pagination={false}
            fullPagination={true}
            defaultWidth={1000}
            columns={columns}
            // data={addresses.slice(1, 5).map((item, i) => {
            data={addresses.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <Link
                      to={`/admin/socio-negocio/datos-maestros/clientes/${item.base_business_partner_id}#direcciones`}
                      target="__blank"
                    >
                      <Visibility />
                    </Link>
                    {item.latitude == '0' || item.longitude == '0' ? (
                      <Button
                        justIcon
                        round
                        simple
                        color={props.themeContext.buttonColorWarning}
                        size="sm"
                        onClick={() => {
                          setShowModalAddress(true);
                          setObjAddress(item);
                        }}
                      >
                        <Edit />
                      </Button>
                    ) : undefined}

                    {(item.latitude != '0' || item.longitude != '0') && true !== undefined && (
                      <Button
                        justIcon
                        round
                        simple
                        color="info"
                        size="sm"
                        onClick={() => {
                          setOpenInfo(true);
                          setInfoData(item);
                          eventClose();
                        }}
                      >
                        <Map />
                      </Button>
                    )}
                  </div>
                ),
                CardCode: item.CardCode,
                CardName: item.CardName,
                Address2: item.Address2,
                billAddress: item.billAddress || 'No encontrado',
                stateImg: (
                  <img
                    height={32}
                    src={
                      item.state === 'A' && item.frozenFor === 'N'
                        ? '/img/GoogleMarker.png'
                        : '/img/marker_gray.png'
                    }
                  />
                ),
                state: item.state === 'A' && item.frozenFor === 'N' ? 'Activo' : 'Inactivo',
                latitude: item.latitude,
                longitude: item.longitude,
                actions: '',
              };
            })}
          />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={eventClose} color="danger" size="sm">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {showModalAddress == true ? (
        <AddressModal
          open={showModalAddress}
          setOpen={setShowModalAddress}
          addressId={objAddress.id}
          bPartner={objAddress.base_business_partner_id}
          disabled
          reload={getAddress}
          showNotify={showNotify}
          layers={layers}
        />
      ) : undefined}

      <GridContainer style={{ width: 'calc(100% + 0px)', margin: '0' }}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Mapa
            </Typography>
          </Toolbar>
        </AppBar>
        <GridItem xs={12} sm={12} className={classes.grid}>
          <GridContainer>
            <GridItem xs={12} sm={12}>
              {/* Info */}
              <GridContainer>
                <GridItem xs={12}>
                  <div className={classes.details}>
                    <span>
                      Ruta: {route.description}
                      {route.layer && (
                        <LayerColorIcon
                          layer={route.layer}
                          style={{ display: 'inline-block', position: 'relative', top: '3px' }}
                        />
                      )}
                    </span>
                    <span>Zona: {route.base_zone_description}</span>
                    <span>Direcciones: {addresses.length}</span>

                    <Button
                      justIcon
                      round
                      size="sm"
                      color="primary"
                      className={classes.btnEye}
                      onClick={handleClickOpen}
                    >
                      <Visibility />
                    </Button>
                    <span>
                      Direcciones con marcador:{' '}
                      {addresses.filter((address) => address.longitude != '0').length}
                    </span>
                    <span>
                      Direcciones sin marcador:{' '}
                      {
                        addresses.filter(
                          (address) => address.longitude == '0' || address.latitude == '0',
                        ).length
                      }
                    </span>
                  </div>
                </GridItem>
              </GridContainer>

              {/* Edición y título de rutas */}
              <GridContainer>
                <GridItem xs={12}>
                  <div className={classes.detailsHover}>
                    <span>{hoverDescription}</span>
                  </div>
                </GridItem>
                <GridItem xs={12}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <AllowedGuard permission={ConstantPermissions.BASE_ROUTES_POLYGON_UPDATE}>
                      {!!route ? (
                        !!route.geometry ? (
                          buttonUpdate ? (
                            <GridContainer>
                              <GridItem xl={2}>
                                <h5>Edicion: </h5>
                                <Tooltip title="Guardar">
                                  <Button
                                    justIcon
                                    round
                                    color="success"
                                    onClick={updatePolygon}
                                    disabled={routeHistory.length <= 1}
                                  >
                                    <Save />
                                  </Button>
                                </Tooltip>
                                <Tooltip title="Cancelar">
                                  <Button justIcon round color="danger" onClick={cancelUpdate}>
                                    <Clear />
                                  </Button>
                                </Tooltip>
                                <Tooltip title="Retroceder">
                                  <Button
                                    justIcon
                                    round
                                    color="warning"
                                    onClick={historyUndo}
                                    disabled={routeHistory.length <= 1}
                                  >
                                    <Restore />
                                  </Button>
                                </Tooltip>
                              </GridItem>
                              <GridItem xl={2}>
                                <h5>Vértices : {route.geometry.length}</h5>
                                <Tooltip title="Eliminar vértice del inicio">
                                  <Button
                                    justIcon
                                    round
                                    color="danger"
                                    onClick={() => removeVertex(true)}
                                  >
                                    <KeyboardArrowLeft />
                                  </Button>
                                </Tooltip>
                                <Tooltip title="Eliminar vértice del final">
                                  <Button
                                    justIcon
                                    round
                                    color="danger"
                                    onClick={() => removeVertex(false)}
                                  >
                                    <KeyboardArrowRight />
                                  </Button>
                                </Tooltip>
                              </GridItem>
                              <GridItem xl={2}>
                                <h5>Visibilidad</h5>
                                <Tooltip
                                  title={showAddresses ? 'Ocultar direcciones' : 'Ver direcciones'}
                                >
                                  <Button
                                    justIcon
                                    round
                                    color="info"
                                    onClick={() => setShowAddresses((show) => !show)}
                                  >
                                    {showAddresses ? <LocationOff /> : <LocationOn />}
                                  </Button>
                                </Tooltip>
                                <Tooltip
                                  title={
                                    showOriginalGeometry
                                      ? 'Ocultar polígono guía'
                                      : 'Ver polígono guía'
                                  }
                                >
                                  <Button
                                    justIcon
                                    round
                                    color="info"
                                    onClick={() => setShowOriginalGeometry((show) => !show)}
                                  >
                                    {showOriginalGeometry ? <GpsOff /> : <GpsFixed />}
                                  </Button>
                                </Tooltip>
                                <Tooltip
                                  title={
                                    showReferenceRoutes
                                      ? 'Ocultar polígonos de referencia'
                                      : 'Ver polígonos de referencia'
                                  }
                                >
                                  <Button
                                    justIcon
                                    round
                                    color="info"
                                    onClick={() => setShowReferenceRoutes((show) => !show)}
                                  >
                                    {showReferenceRoutes ? <VisibilityOff /> : <Visibility />}
                                  </Button>
                                </Tooltip>
                              </GridItem>
                            </GridContainer>
                          ) : (
                            <Button justIcon round color="warning" onClick={startUpdate}>
                              <Edit />
                            </Button>
                          )
                        ) : (
                          <Button
                            justIcon
                            round
                            color="success"
                            onClick={() => {
                              createPolygon();
                            }}
                          >
                            {!!newPolygon ? <Save /> : <Add />}
                          </Button>
                        )
                      ) : undefined}
                    </AllowedGuard>
                  </div>
                </GridItem>
              </GridContainer>

              {/* Filtros */}
              <GridContainer>
                {bureaus.length > 0 && (
                  <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                    <FormControl fullWidth margin="normal" size="small">
                      <InputLabel>Filtro de mesas</InputLabel>
                      <Select
                        value={selectedBureau?.id || 'N'}
                        onChange={(e) => {
                          if (e.target.value === 'N') {
                            setSelectedBureau(undefined);
                            return;
                          }
                          setSelectedBureau(bureaus.find((item) => item.id === e.target.value));
                        }}
                      >
                        <MenuItem value="N">No filtrar</MenuItem>
                        {bureaus.map((bureau) => (
                          <MenuItem value={bureau.id} key={bureau.id}>
                            {bureau.description}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                )}

                <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>Filtro por estado:</InputLabel>
                    <Select
                      value={stateFilter}
                      onChange={(e) => {
                        setStateFilter(e.target.value);
                      }}
                    >
                      <MenuItem value="A">Activos</MenuItem>
                      <MenuItem value="I">Inactivos</MenuItem>
                      <MenuItem value="T">Todo</MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>

                {layers !== undefined && (
                  <>
                    <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                      <LayerCombo isFilter label="Filtro de capas" layers={layers} />
                    </GridItem>
                  </>
                )}

                <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                  <FormControlLabel
                    label="Mostrar nombres"
                    control={
                      <Checkbox
                        margin="normal"
                        checked={showMarkerLabels}
                        onChange={(e) => setShowMarkerLabels(e.target.checked)}
                      />
                    }
                  />
                </GridItem>
              </GridContainer>

              {/* Leyendas */}
              <GridContainer style={{ marginTop: '5px' }}>
                {layers !== undefined && (
                  <GridItem xs={12} md={6}>
                    <LayerLegend extraLayers={[{ color: '#000000', name: 'Ruta actual' }]} />
                  </GridItem>
                )}
                <GridItem xs={12} md={6}>
                  <Legend
                    legends={[
                      {
                        imageSrc: '/img/GoogleMarker.png',
                        title: 'Dirección activa',
                      },
                      {
                        imageSrc: '/img/marker_gray.png',
                        title: 'Dirección inactiva',
                      },
                    ]}
                  />
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} className={classes.grid}>
              <GoogleMapCustom
                onMouseOut={() => {
                  setHoverDescription(null);
                }}
                onLoad={(map) => {
                  setMapRef(map);
                }}
                mapContainerStyle={{
                  width: '100%',
                  // height: '80%',
                  minHeight: '620px',
                }}
                zoom={14}
                center={mapCenter}
                onDragEnd={() => {
                  if (!mapRef) return;
                  let center = {
                    lat: mapRef.center.lat(),
                    lng: mapRef.center.lng(),
                  };
                  setMapCenter(center);
                }}
                options={{
                  disableDoubleClickZoom: true,
                }}
                onClick={() => {
                  setOpenInfo(false);
                  setDraggable({
                    state: false,
                    icon: '',
                    idAddress: null,
                  });
                }}
                onRightClick={(e) => {
                  alert(`Lat: ${e.latLng.lat()}\nLng: ${e.latLng.lng()}`);
                }}
              >
                {!!newPolygon ? (
                  <Polygon
                    ref={newPolygonRef}
                    editable
                    draggable
                    options={{
                      fillColor: 'green',
                    }}
                    paths={newPolygon.paths}
                  />
                ) : undefined}

                {showAddresses &&
                  addresses
                    .filter((address) => address.latitude != '0')
                    .map((address, i) => {
                      return (
                        <Marker
                          onMouseOver={(e) => {
                            setHoverDescription('Dirección: ' + address.Address2);
                          }}
                          key={i}
                          zIndex={10}
                          position={{
                            lat: parseFloat(address.latitude),
                            lng: parseFloat(address.longitude),
                          }}
                          onClick={() => {
                            setOpenInfo(true);
                            setInfoData(address);
                          }}
                          onMouseOut={() => {
                            setHoverDescription('"Pase el mouse por un polígono o marcador"');
                          }}
                          onRightClick={() => {
                            setDraggable({
                              state: true,
                              icon: '/img/marker.png',
                              idAddress: address.id,
                            });
                            setNewMarker({
                              lat: parseFloat(address.latitude),
                              lng: parseFloat(address.longitude),
                            });
                          }}
                          icon={
                            draggable.idAddress == address.id && draggable.state
                              ? draggable.icon
                              : address.state === 'A' && address.frozenFor === 'N'
                              ? undefined
                              : '/img/marker_gray.png'
                          }
                          label={
                            showMarkerLabels
                              ? {
                                  color: 'white',
                                  className: 'map-label',
                                  text: address.CardName.substr(0, address.CardName.indexOf(' ')),
                                }
                              : undefined
                          }
                        />
                      );
                    })}

                {draggable.state ? (
                  <Marker
                    zIndex={100}
                    position={{
                      lat: newMarker.lat,
                      lng: newMarker.lng,
                    }}
                    draggable={true}
                    icon={'/img/mark.png'}
                    onDragEnd={(e) => {
                      setNewMarker({
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng(),
                      });
                    }}
                    onRightClick={(e) => {
                      udateMarker({
                        latitude: e.latLng.lat().toString(),
                        longitude: e.latLng.lng().toString(),
                      });
                    }}
                  />
                ) : undefined}

                {!!route ? (
                  !!route.geometry ? (
                    originalRoute === undefined ? (
                      <Polygon
                        onClick={() => {
                          setDraggable({
                            state: false,
                            icon: '',
                            idAddress: null,
                          });
                        }}
                        onMouseOver={(e) => {
                          setHoverDescription('Ruta: ' + route.description);
                        }}
                        options={{
                          fillColor: buttonUpdate ? 'green' : undefined,
                        }}
                        paths={route.geometry}
                        onMouseOut={() => {
                          setHoverDescription('"Pase el mouse por un polígono o marcador"');
                        }}
                      />
                    ) : (
                      <Polygon
                        onClick={() => {
                          setDraggable({
                            state: false,
                            icon: '',
                            idAddress: null,
                          });
                        }}
                        onMouseOver={(e) => {
                          setHoverDescription('Ruta: ' + route.description);
                        }}
                        onMouseUp={onMouseUpEdit}
                        editable={buttonUpdate}
                        draggable={buttonUpdate}
                        options={{
                          fillColor: buttonUpdate ? 'green' : undefined,
                        }}
                        ref={routePolygon}
                        paths={route.geometry}
                        onMouseOut={() => {
                          setHoverDescription('"Pase el mouse por un polígono o marcador"');
                        }}
                      />
                    )
                  ) : undefined
                ) : undefined}

                {showReferenceRoutes &&
                  filteredRefferenceRoutes.map((routeRef, i) => {
                    return !!routeRef.geometry ? (
                      <Polygon
                        onMouseOver={(e) => {
                          setHoverDescription('Ruta: ' + routeRef.description);
                        }}
                        key={i}
                        paths={routeRef.geometry}
                        options={{
                          fillColor: routeRef.layer.color,
                        }}
                        onMouseOut={() => {
                          setHoverDescription('"Pase el mouse por un polígono o marcador"');
                        }}
                      />
                    ) : undefined;
                  })}

                {/* Poligono guía */}
                {showOriginalGeometry && originalRoute !== undefined ? (
                  <Polygon
                    options={{
                      fillOpacity: 0.1,
                      zIndex: -1,
                    }}
                    paths={originalRoute.geometry}
                  />
                ) : undefined}

                {openInfo ? (
                  <InfoWindow
                    position={{
                      lat: parseFloat(infoData.latitude),
                      lng: parseFloat(infoData.longitude),
                    }}
                    onCloseClick={() => {
                      setOpenInfo(false);
                      setInfoData({});
                    }}
                    options={{
                      pixelOffset: {
                        width: 0,
                        height: -25,
                      },
                    }}
                  >
                    <div className={classes.divStyle}>
                      <li>
                        <span>Nombre: </span>
                        {infoData.CardName}
                      </li>
                      <li>
                        <span>Dir: </span>
                        {infoData.Address2}
                      </li>
                    </div>
                  </InfoWindow>
                ) : undefined}
              </GoogleMapCustom>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </Dialog>
  );
});
